import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    groups: {
      legal: {
        description:
          'You’re not alone: lawyers are available to answer your legal questions 6 days a week',
        title: 'Legal assistance',
      },
      materialAndBody: {
        description: 'Protect yourself from everyday accidents with Shine',
        title: 'Material and body insurance',
      },
      payment: {
        description: 'Strengthen your defense against malicious online acts',
        title: 'Payment insurance',
      },
      travel: {
        description: 'Travel with peace of mind thanks to your Shine card',
        title: 'Travel insurances',
      },
    },
    offers: {
      accidentCoverage: {
        description: 'We’ve got your back if you are admitted to the hospital',
        title: 'Accident coverage',
      },
      computerBreakage: {
        description:
          'Shine repairs or replaces your computer in case of damage or theft.',
        title: 'Laptop',
      },
      debtRecovery: {
        description:
          'Unpaid bills? Get help from a specialized lawyer for your claims.',
        title: 'Recovery assistance',
      },
      fromPartners: {
        description:
          'Multi-risk professional liability: we have selected the most suitable insurances for you',
        title: 'Insurances from our partners',
      },
      healthCostsAbroad: {
        description:
          "Travel with peace of mind anywhere in the world: we've got your back in case of health issues during your trip.",
        title: 'Healthcare Expenses Abroad',
      },
      hospitalization: {
        description:
          'Because we know accidents can be very costly: Shine compensates you in case of hospitalization.',
        title: 'Hospitalization Insurance',
      },
      legalAssistance: {
        description:
          'Have a question about your business? A team of lawyers is available to answer it.',
        title: 'Legal assistance',
      },
      mobileScreen: {
        description:
          'Does your phone slips out of your hands? Screen repair is included.',
        title: 'Phone screen breakage',
      },
      paymentFraud: {
        description:
          'Your card has been stolen or lost? You are covered in case of fraudulent use.',
        title: 'Payment Fraud',
      },
      phishing: {
        description:
          'Victim of personal information theft? Our advisors are here to support you 7 days a week.',
        title: 'Phishing',
      },
      purchaseProtection: {
        description:
          'In case of damage or theft, your items paid for with the Shine card are insured for 60 days.',
        title: 'Purchase Protection',
      },
      rentalVehicle: {
        description:
          'Hit the road with peace of mind, your deductible is covered in case of accident or vandalism.',
        title: 'Rental Vehicle',
      },
      transportDelay: {
        description:
          'Is your train or flight delayed? Get up to €1,000 in compensation.',
        title: 'Transport Delay',
      },
      warrantyExtension: {
        description:
          'Shine doubles your product’s warranty... And your peace of mind',
        title: 'Extended equipment warranty',
      },
    },
    title: 'Manage your insurance directly from the Shine mobile app!',
  },
  fr: {
    groups: {
      legal: {
        description:
          'Plus jamais seul·e : nos juristes sont disponibles 6j / 7 pour répondre à vos questions légales !',
        title: 'Accompagnement juridique',
      },
      materialAndBody: {
        description: 'Protégez-vous des accidents du quotidien avec Shine.',
        title: 'Assurance matériel et corporel',
      },
      payment: {
        description:
          'Renforcez votre défense face aux actes malveillants en ligne.',
        title: 'Assurance aux moyens de paiement',
      },
      travel: {
        description:
          'Déplacez vous l’esprit tranquille grâce à votre carte Shine !',
        title: 'Assurances voyages',
      },
    },
    offers: {
      accidentCoverage: {
        description: 'Nous assurons vos arrières en cas d’hospitalisation',
        title: 'Garantie accident',
      },
      computerBreakage: {
        description:
          'Shine répare ou remplace votre ordinateur, en cas de casse ou de vol.',
        title: 'Ordinateur portable',
      },
      debtRecovery: {
        description:
          'Des factures impayées ? Obtenez de l’aide d’un·e juriste spécialisé·e pour vos créances.',
        title: 'Assistance recouvrement',
      },
      fromPartners: {
        description:
          'RC pro, multirisques\xa0:\xa0nous avons sélectionné les assurances les plus adaptées pour vous',
        title: 'Assurances de nos partenaires',
      },
      healthCostsAbroad: {
        description:
          'Voyagez tranquille partout dans le monde : nous assurons vos arrières en cas de problème de santé lors d’un déplacement.',
        title: 'Frais de santé à l’étranger',
      },
      hospitalization: {
        description:
          'Parce que nous savons que les accidents peuvent coûter très cher : Shine vous indemnise en cas d’hospitalisation.',
        title: 'Assurance hospitalisation',
      },
      legalAssistance: {
        description:
          'Une question sur votre activité ? Une équipe de juristes est disponible pour y répondre.',
        title: 'Assistance juridique',
      },
      mobileScreen: {
        description:
          'Votre téléphone vous glisse des mains\xa0? La réparation de l’écran est assurée.',
        title: 'Casse écran téléphone',
      },
      paymentFraud: {
        description:
          'Votre carte a été volée ou est perdue ? Vous êtes couvert en cas d’utilisation frauduleuse.',
        title: 'Fraude au moyen de paiement',
      },
      phishing: {
        description:
          'Victime du vol de vos informations personnelles ? Nos conseiller·es sont là pour vous accompagner 7j /7.',
        title: 'Hameçonnage',
      },
      purchaseProtection: {
        description:
          'En cas de casse ou de vol, vos biens payés avec la carte Shine sont assurés pendant 60 jours.',
        title: 'Protection des achats',
      },
      rentalVehicle: {
        description:
          'Prenez la route en toute sérénité, votre franchise est rachetée en cas d’accident ou de vandalisme.',
        title: 'Véhicule de location',
      },
      transportDelay: {
        description:
          'Votre train ou votre vol a du retard ? Obtenez jusqu’à 1 000 € d’indemnisation.',
        title: 'Retard de transport',
      },
      warrantyExtension: {
        description:
          'Shine double la garantie de votre matériel... Et votre tranquillité avec',
        title: 'Extension de garantie',
      },
    },
    title: 'Gérez vos assurances directement depuis l’appli mobile Shine\xa0!',
  },
} as const);

export default locales;
